import { green, red, orange, purple, blue, deepOrange, teal, amber } from '@mui/material/colors'
import { PAYMENT_STATUS } from 'settings/constants/payment'

const { APPROVED, REVERSED, VOIDED, REFUNDED, DECLINED, TRANSFERRED, FAILED, PENDING, PROCESSED } = PAYMENT_STATUS

export const PAYMENT_STATUS_COLORS = {
  [APPROVED]: green,
  [REVERSED]: orange,
  [VOIDED]: amber,
  [REFUNDED]: teal,
  [TRANSFERRED]: purple,
  [DECLINED]: deepOrange,
  [FAILED]: red,
  [PENDING]: blue,
  [PROCESSED]: orange,
}
